<template>
  <v-app>
    <v-main>
      <AppNavbar />
      <Authenticator :hide-sign-up="true">
        <template v-slot:header>
          <IconLogoWorkstateMedium />
        </template>
        <Suspense>
          <template #fallback>
            Loading...
          </template>
          <router-view />
        </Suspense>
      </Authenticator>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">

import AppNavbar from '@/components/AppNavbar.vue';
import IconLogoWorkstateMedium from '@/components/icons/logos/IconLogoWorkstateMedium.vue';
import { Authenticator } from "@aws-amplify/ui-vue";
import "@aws-amplify/ui-vue/styles.css";
import { Amplify } from "aws-amplify";

const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "";
const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? "";
const identityPoolId = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID ?? "";
const graphQlApiEndpoint = import.meta.env.VITE_GRAPHQL_API_ENDPOINT ?? "";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: userPoolId,
      userPoolClientId: userPoolClientId,
      identityPoolId: identityPoolId,
      loginWith: {
        username: true,
        email: true,
      },
      allowGuestAccess: false,
    },
  },
  API: {
    GraphQL: {
      endpoint: graphQlApiEndpoint,
      defaultAuthMode: "userPool",
      region: "us-east-1"
    }
  }
})
</script>

<style>
[data-amplify-authenticator] {
  --amplify-components-authenticator-router-box-shadow: 0 0 16px var(--amplify-colors-overlay-10);
  --amplify-components-authenticator-router-border-width: 0;
  --amplify-components-button-primary-background-color: rgb(var(--v-theme-primary));
  --amplify-components-button-primary-hover-background-color: rgb(var(--v-theme-primary-lighten-2));
  --amplify-components-button-link-hover-background-color: rgb(var(--v-theme-primary-lighten-8));
  --amplify-components-button-hover-background-color: rgb(var(--v-theme-primary-lighten-8));
  --amplify-components-button-link-color: rgb(var(--v-theme-primary));
  height: 60vh;
}
</style>
